import { useMemo, useState } from 'react';
import { leakCategories, leakList } from '@/mocks/homeData';

export default function LatestLeaks() {
  const [active, setActive] = useState('all');

  const visible = useMemo(
    () => (active === 'all' ? leakList : leakList.filter((item) => item.category === active)),
    [active],
  );

  return (
    <section id="leaks" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-xs tracking-[0.3em] text-primary-600">LATEST</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              最新爆料速览
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              按发布时间倒序排列，只留标题与一句话摘要，快速扫完不占屏。
            </p>
          </div>
          <div className="flex flex-wrap gap-1 rounded-full border border-background-200 bg-background-100 p-1">
            {leakCategories.map((cat) => (
              <button
                key={cat.id}
                type="button"
                onClick={() => setActive(cat.id)}
                className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs transition-colors ${
                  active === cat.id
                    ? 'bg-primary-500 font-medium text-background-50'
                    : 'text-foreground-600 hover:text-primary-600'
                }`}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {visible.length === 0 ? (
            <div className="flex flex-col items-center gap-2 py-16 text-foreground-500">
              <i className="ri-inbox-line text-3xl" aria-hidden="true" />
              <p className="text-sm">该分类暂时还没有内容，换个分类看看吧。</p>
            </div>
          ) : (
            <ul className="divide-y divide-background-200">
              {visible.map((item) => (
                <li key={item.id}>
                  <a
                    href="#community"
                    className="group flex items-start gap-4 px-4 py-4 transition-colors hover:bg-background-100 md:px-6 md:py-5"
                  >
                    <span className="hidden w-14 shrink-0 pt-0.5 text-center md:block">
                      <span className="font-heading text-base font-bold text-primary-600">{item.date}</span>
                    </span>
                    <span className="flex min-w-0 flex-1 flex-col">
                      <span className="flex flex-wrap items-center gap-2">
                        <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900 md:hidden">
                          {item.date}
                        </span>
                        {item.hot && (
                          <span className="inline-flex items-center gap-1 rounded-md bg-primary-100 px-2 py-0.5 text-[11px] font-medium text-primary-700">
                            <i className="ri-fire-fill" aria-hidden="true" />
                            热
                          </span>
                        )}
                        <span className="font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                          {item.title}
                        </span>
                      </span>
                      <span className="mt-1.5 line-clamp-2 text-sm text-foreground-600">{item.excerpt}</span>
                      <span className="mt-2 flex items-center gap-4 text-xs text-foreground-400">
                        <span className="flex items-center gap-1">
                          <i className="ri-eye-line" aria-hidden="true" />
                          {item.views}
                        </span>
                        <span className="flex items-center gap-1">
                          <i className="ri-chat-3-line" aria-hidden="true" />
                          {item.replies}
                        </span>
                      </span>
                    </span>
                    <i
                      className="ri-arrow-right-up-line mt-1 shrink-0 text-foreground-300 transition-colors group-hover:text-primary-500"
                      aria-hidden="true"
                    />
                  </a>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="mt-5 flex justify-center">
          <button
            type="button"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-history-line" aria-hidden="true" />
            查看更多历史爆料
          </button>
        </div>
      </div>
    </section>
  );
}